import React from 'react'
import Toaster, { ToasterProvider } from './Toaster'
import ConfirmDialog, { ConfirmProvider } from './ConfirmDialog'
import { OnlineStatusProvider } from '../hooks/useOnlineStatus'
import { ThemeProvider } from '@material-ui/core/styles';
import { MuiPickersUtilsProvider, } from '@material-ui/pickers';
import Store from '../Store';
import MomentUtils from '@date-io/moment'
import theme from '../theme.js'

const AppProviders = ({ children }) => {
    return (
        <Store>
            <ThemeProvider theme={theme}>
                <ToasterProvider>
                    <OnlineStatusProvider>
                        <ConfirmProvider>
                            <MuiPickersUtilsProvider utils={MomentUtils}>
                                {children}
                                <Toaster />
                                <ConfirmDialog />
                            </MuiPickersUtilsProvider>
                        </ConfirmProvider>
                    </OnlineStatusProvider>
                </ToasterProvider>
            </ThemeProvider>
        </Store>
    )
}

export default AppProviders
